module.exports = __webpack_public_path__ + "img/20200104130855360截图20200104101509906.b822df9f.jpg";